import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
import { client } from '../../../utils/apolloClient';

const initialState = {
  loading: false,
  error: false,
  success: false,
  urlProvisioning: false,
  redirectURL: '',
  entityID: '',
  urlParams: ''
};
export const getURL = createAsyncThunk(
  'getURL',
  async ({url,type, ids, token}) => {
    let response = await client.authorizeRequest({
      method: 'POST',
      url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/provisionalsetting`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        url,
        type,
        ids
    }
    });
    return response.data;
  }
);

export const provisionSettings= createSlice({
  name: 'getURL',
  initialState,
  reducers: {
    clearProvisioningSettings: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
    },
    setProvisioning: (state, action) => {
      state.urlProvisioning = true;
      state.redirectURL = action.payload.redirectURL;
      state.entityID = action.payload.entityID;
    },
    setUrlParams: (state, action) => {
      state.urlParams = action.payload;
    }
  },
  extraReducers: {
    [getURL.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      window.open(action.payload.url);
    },
    [getURL.pending]: (state, action) => {
        state.loading = true;
        state.error = false;
        state.success = false;
    },
    [getURL.rejected]: (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
    }
  }
});

export const {
  clearProvisioningSettings,
  setProvisioning,
  setUrlParams
} = provisionSettings.actions;

export default provisionSettings.reducer;